import {
  ServicesHeroSection,
  ServicesListSection,
  ServicesJourneySection,
} from '@/components/sections'

export const ServicesPage = () => (
  <main>
    <ServicesHeroSection />
    <ServicesListSection />
    <ServicesJourneySection />
  </main>
)
